import deadLetterEventsSlice from './deadLetterEventsSlice'
export default deadLetterEventsSlice.reducer
